export const FILTER_TYPES = {
    ModelSerie: 'ModelSerie',
    ModelBodyType: 'ModelBodyType',
    ModelDriveType: 'ModelDriveType',
    ModelDrivingForce: 'ModelDrivingForce',
    ModelTransmission: 'ModelTransmission'
  } as const;
  
  export type FilterType = typeof FILTER_TYPES[keyof typeof FILTER_TYPES];